@let limit = $limit();
@let total = $total!();
@let currentPage = $currentPage();
@let isLoading = !!(isLoading$ | async);
@let isDesktop = deviceService.isDesktop$ | async;

@if (total > 0) {
  @if (isDesktop) {
    <div class="flex gap-[380px] items-center">
      <!--    ЛИМИТ-->
      <section>
        <tui-textfield
          tuiChevron
          class="bg-(--tui-background-base-alt) border border-(--tui-border-normal) w-[220px] select-without-shadow"
          [content]="limitValueContent"
          tuiTextfieldSize="m"
        >
          <input
            tuiSelect
            [ngModel]="limit"
            (ngModelChange)="setLimit($event)"
          />
          <tui-data-list-wrapper
            [itemContent]="limitContent"
            *tuiDropdown
            [items]="[10, 50, 100]"
          ></tui-data-list-wrapper>
        </tui-textfield>
        <ng-template #limitValueContentTpl let-limitData>
          <p class="x-font-body-5-bold">
            {{ 'pagination.requests_per_page' | translate }}
            <span class="ms-1">{{ limitData }}</span>
          </p>
        </ng-template>
        <ng-template #limitContentTpl let-limit>
          <p class="x-font-body-5-bold">{{ limit }}</p>
        </ng-template>
      </section>
      <!--    ПАГИНАЦИЯ-->
      <div
        class="flex items-center flex-col basis-1/2 sm:basis-auto mt-1 sm:mt-0"
      >
        <div class="x-font-body-4-bold text-center">
          {{ 'pagination.page' | translate }}
          <ng-container [ngTemplateOutlet]="paginationButtons" />
        </div>
        <div class="x-font-body-4-bold ms-4 me-4 mt-1">
          {{ showedOn }} - {{ showedFor }} {{ 'pagination.of' | translate }}
          {{ total }}
        </div>
      </div>
    </div>
  } @else {
    <div
      class="flex sm:justify-center justify-around items-center flex-col sm:flex-row md:ms-[-30%]"
    >
      <span class="flex items-center md:flex-row flex-col">
        <span class="sm:mr-2 x-font-body-5 mb-2 sm:mb-0">
          {{ 'pagination.entries_per_page' | translate }}
        </span>
        <span>
          <button
            size="s"
            [appearance]="limit === 10 ? 'primary' : 'outline'"
            tuiButton
            type="button"
            class="sm:mr-2 mr-0.5"
            (click)="setLimit(10)"
          >
            <span class="x-font-body-5-bold">10</span>
          </button>
          <button
            size="s"
            [appearance]="limit === 50 ? 'primary' : 'outline'"
            tuiButton
            type="button"
            class="sm:mr-2 mr-0.5"
            [disabled]="total <= 10"
            (click)="setLimit(50)"
          >
            <span class="x-font-body-5-bold">50</span>
          </button>
          <button
            size="s"
            [appearance]="limit === 100 ? 'primary' : 'outline'"
            tuiButton
            type="button"
            [disabled]="total <= 50"
            class="sm:mr-2 mr-0.5"
            (click)="setLimit(100)"
          >
            <span class="x-font-body-5-bold">100</span>
          </button>
        </span>
      </span>
      <div
        class="flex items-center flex-col sm:flex-row basis-1/2 sm:basis-auto mt-1 sm:mt-0"
      >
        <span class="x-font-body-5 ms-4 me-4">
          {{ showedOn }} - {{ showedFor }} {{ 'pagination.of' | translate }}
          {{ total }}
        </span>
        <div class="x-font-body-5 text-center">
          {{ 'pagination.page' | translate }}
          <ng-container [ngTemplateOutlet]="paginationButtons" />
        </div>
      </div>
    </div>
  }
}

<ng-template #paginationButtons>
  <ul class="inline-flex items-center">
    <li
      [ngClass]="
        currentPage === 1 || isLoading ? 'cursor-not-allowed' : 'cursor-pointer'
      "
    >
      <a
        (click)="prevPage()"
        [ngClass]="{ disabled: currentPage === 1 || isLoading }"
      >
        <tui-icon icon="@tui.chevron-left" class="size-6 text-base"></tui-icon>
      </a>
    </li>
    @if (overflow.left) {
      <li class="p-1 cursor-default">...</li>
    }
    @for (page of pageAr; track page; let count = $count) {
      <li
        [ngClass]="currentPage === 1 ? 'cursor-not-allowed' : 'cursor-pointer'"
      >
        <button
          tuiButton
          [size]="(deviceService.isDesktop$ | async) ? 's' : 'xs'"
          (click)="setPage(page)"
          [appearance]="currentPage === page ? 'primary' : 'flat'"
          [ngClass]="{ 'me-1': count > 1 }"
          [disabled]="count <= 1"
        >
          <span class="x-font-body-4-bold">
            {{ page }}
          </span>
        </button>
      </li>
    }
    @if (overflow.right) {
      <li class="p-1 cursor-default">...</li>
    }
    <li
      [ngClass]="
        lastPage || isLoading ? 'cursor-not-allowed' : 'cursor-pointer'
      "
    >
      <a (click)="nextPage()" [ngClass]="{ disabled: lastPage || isLoading }">
        <tui-icon icon="@tui.chevron-right" class="size-6 text-base"></tui-icon>
      </a>
    </li>
  </ul>
</ng-template>
